const routes = [
    {
        path: '/win/detail',
        component: function () {
            return import('@/components/admin/organization/DetailInfo')
        }
    },
    {
        path: '/win/list',
        component: function () {
            return import('@/components/admin/win/ArticleList')
        }
    },
    {
        path: '/win/article/info',
        component: function () {
            return import('@/components/admin/win/ArticleInfo')
        }
    },
    {
        path: '/win/home',
        name: 'win_home',
        component: function () {
            return import('@/components/admin/win/Home')
        }
    },
    {
        path: '/win/left_top',
        name: 'win_left_top',
        component: function () {
            return import('@/components/admin/win/LeftTop')
        }
    },
    {
        path: '/win/left_top/add',
        name: 'win_left_top_add',
        component: function () {
            return import('@/components/admin/win/LeftTopAdd')
        }
    },
    {
        path: '/win/left_bottom',
        name: 'win_left_bottom',
        component: function () {
            return import('@/components/admin/win/LeftBottom')
        }
    },
    {
        path: '/win/left_bottom/add',
        name: 'win_left_bottom_add',
        component: function () {
            return import('@/components/admin/win/LeftBottomAdd')
        }
    },
    {
        path: '/win/right',
        name: 'win_right',
        component: function () {
            return import('@/components/admin/win/Right')
        }
    },
    {
        path: '/win/right/add',
        name: 'win_right_add',
        component: function () {
            return import('@/components/admin/win/RightAdd')
        }
    },
    {
        path: '/win/video',
        name: 'win_video',
        component: function () {
            return import('@/components/admin/win/Video')
        }
    },
    {
        path: '/win/video/add',
        name: 'win_video_add',
        component: function () {
            return import('@/components/admin/win/VideoAdd')
        }
    },
    {
        path: '/win/activity',
        name: 'win_activity',
        component: function () {
            return import('@/components/admin/win/Activity')
        }
    },
    {
        path: '/win/activity/add',
        name: 'win_activity_add',
        component: function () {
            return import('@/components/admin/win/ActivityAdd')
        }
    },
    {
        path: '/win/article_right',
        name: 'win_article_right',
        component: function () {
            return import('@/components/admin/win/ArticleRight')
        }
    },
    {
        path: '/win/article_right/add',
        name: 'win_article_right_add',
        component: function () {
            return import('@/components/admin/win/ArticleRightAdd')
        }
    },
    {
        path: '/win/category',
        name: 'win_category',
        component: function () {
            return import('@/components/admin/win/Category')
        }
    },
    {
        path: '/win/category/add',
        name: 'win_category_add',
        component: function () {
            return import('@/components/admin/win/CategoryAdd')
        }
    },
]

export default routes
